/** Evento disparado após persistir o ID padrão do vendedor (Doey) da instituição. */
export const INSTITUTION_PAYMENT_GATEWAY_UPDATED_EVENT =
  'legalprime:institution-payment-gateway-updated' as const

/** Indica se a instituição possui ID padrão do vendedor Doey configurado. */
export function hasInstitutionDefaultDoeySellerId(
  sellerId: string | null | undefined
): boolean {
  return Boolean(sellerId?.trim())
}

/** Notifica ouvintes (ex.: sidebar) para reavaliar o estado do gateway. */
export function notifyInstitutionPaymentGatewayUpdated(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(INSTITUTION_PAYMENT_GATEWAY_UPDATED_EVENT))
}
